<template>
  <div
    class="dui-word-count grid-flex grid-middle grid-no-response text-grey-dark"
    :class="{ 'text-red-base': invalidLength }"
  >
    <div
      v-if="invalidLength"
      class="grid-item-shrink"
    >
      Please delete some words
    </div>
    <div class="grid-item text-right">
      <span>{{ currentLength }}</span><span v-if="maxWords">/{{ maxWords }}</span> words
    </div>
  </div>
</template>

<script>
import duiWordCount from '@dui/filters/dui-word-count/dui-word-count';

export default {
  props: {
    maxWords: {
      type: Number,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    currentLength() {
      return duiWordCount(this.value);
    },
    invalidLength() {
      if (!this.maxWords || !this.value) {
        return false;
      }

      return (this.currentLength > this.maxWords);
    },
  },
};
</script>
